import { useState } from 'react'
import { api, setToken, ApiError } from '../adminApi'

export function AdminLogin({ onAuthed }: { onAuthed: () => void }) {
  const [password, setPassword] = useState('')
  const [error, setError] = useState<string | null>(null)
  const [busy, setBusy] = useState(false)

  async function submit(e: React.FormEvent) {
    e.preventDefault()
    setError(null); setBusy(true)
    try {
      const res = await api.login(password)
      setToken(res.accessToken)
      onAuthed()
    } catch (err) {
      setError(err instanceof ApiError ? err.message : 'Что-то пошло не так.')
    } finally {
      setBusy(false)
    }
  }

  return (
    <div className="auth">
      <h1>Вход</h1>
      <p className="sub">Панель управления туннелями.</p>
      {error && <div className="alert err">{error}</div>}
      <form onSubmit={submit}>
        <div className="field">
          <label>Пароль</label>
          <input className="input" type="password" value={password} onChange={(e) => setPassword(e.target.value)} placeholder="••••••••" autoFocus autoComplete="current-password" />
        </div>
        <button className="btn primary block" type="submit" disabled={busy || !password}>
          {busy ? <span className="spin" /> : 'Войти'}
        </button>
      </form>
    </div>
  )
}
